import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { MediaService } from "../../services/media.service";
import { AuthService } from "../../auth.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Media } from "../../model/media";
import { Messages } from "../../model/messages";
import { Ticket } from "../../model/ticket";
import { Navigation } from "../../model/navigation";
import { NavigationHelper } from "../../services/navigation.helper";

@Component({
  selector: "media-list",
  templateUrl: "./media-list.component.html",
  styleUrls: ["./media-list.component.css"],
})
export class MediaListComponent implements OnInit {
  @Input() isMobile: boolean = false;
  @Input() currentTicket: Observable<Ticket>;
  @Output() mediaSelected = new EventEmitter<number>();
  showCreateForm: boolean = false;
  medias: BehaviorSubject<Media[]> = new BehaviorSubject<Media[]>([]);
  messages: BehaviorSubject<Messages> = new BehaviorSubject(Messages.EMPTY);
  selectedMedia: Media | null = null;
  currentTicketId: number | null = null;
  loading: boolean = false;
  editMode: boolean = false;
  title: BehaviorSubject<string> = new BehaviorSubject<string>("media.title");

  constructor(
    private route: ActivatedRoute,
    private mediaService: MediaService,
    private authService: AuthService,
    private router: Router,
    private nav: NavigationHelper
  ) {}

  ngOnInit(): void {
    const token = this.authService.token;

    if (this.currentTicket) {
      this.currentTicket.subscribe((ticket) => {
        this.currentTicketId = ticket.id;

        if (this.currentTicketId && this.currentTicketId > 0) {
          const mediaList = ticket.parts?.media ?? [];

          this.mediaService.accept(mediaList);
          this.medias.next(mediaList);
        }
      });

      this.mediaService.mediaObservable.subscribe((medias) => {
        this.medias.next(medias);
      });
    }

    this.nav.fragmentId.subscribe((id) => {
      const fragmentId = Number(id);

      if (
        this.nav.currentFragmentTopic === "media" &&
        (id === "-9" || Number(id) > 0)
      ) {
        this.showCreateForm = true;
        this.editMode = true;
        const newMedia = new Media(
          -9,
          "",
          0,
          "",
          0,
          false,
          null,
          null,
          null,
          null
        );

        this.selectedMedia = newMedia;
        this.mediaService.select(newMedia);
      }
      if (fragmentId > 0) {
        const found = this.medias.value.find((t) => t.id === fragmentId);

        if (found) {
          this.selectedMedia = found;
          this.mediaService.select(found);

          const action = this.nav.currentAction;

          if (action === "fragment") {
          } else if (action === "fragmentedit") {
            this.editMode = true;
          }
        }
      }
    });
  }

  selectMedia(media: Media): void {
    this.showCreateForm = false;
    this.selectedMedia = media;
    this.mediaService.select(media);

    const mediaId: number = media.id;
    const url =
      "tickets/" + this.currentTicketId + "/fragment/media/" + mediaId;
    if (mediaId) {
      this.router.navigate([url]).then(() => {
        this.mediaSelected.emit(mediaId);
      });
    }
    this.showCreateForm = false;
  }

  createMedia(): void {
    this.selectedMedia = null;
    this.showCreateForm = true;
    const newMedia = new Media(
      Navigation.NEW,
      "",
      0,
      "",
      0,
      false,
      null,
      null,
      null,
      null
    );
    this.mediaService.selectedMedia.next(newMedia);

    const url =
      "tickets/" +
      this.currentTicketId +
      "/fragmentedit/media/" +
      Navigation.NEW;

    this.router.navigate([url]).then(() => {
      this.mediaSelected.emit(Navigation.NEW);
    });
  }
}
